import React from 'react'

import { Box, NumberBadge, Text } from '@factorialco/deprecated-design-system'

type Props = {
  position?: number
  title: string
  uuid: string
  description?: string | null
}

export const AnswerQuestion: React.FC<React.PropsWithChildren<Props>> = ({
  position,
  title,
  description,
  uuid,
  children,
}) => {
  return (
    <Box flexDirection="column" gap="s16">
      <Box gap="s12" id={`question-${uuid}`}>
        <Box flexDirection="row" gap="s12">
          {position && <NumberBadge label={position} />}
          <Text.Normal size="300" weight="medium" color="grey1000" whiteSpace="breakSpaces">
            {title}
          </Text.Normal>
        </Box>
        {description && (
          <Text.Normal size="300" color="grey800" whiteSpace="breakSpaces">
            {description}
          </Text.Normal>
        )}
      </Box>
      <Box width="full">{children}</Box>
    </Box>
  )
}
